import React from 'react'
export const wsuperoethb = {
  path: (
    <>
      <circle
        cx="13"
        cy="13"
        r="13"
        transform="matrix(0.258819 0.965926 0.965926 -0.258819 0.905762 6.7334)"
        fill="url(#paint0_linear_15322_4821)"
      />
      <path
        opacity="0.2"
        d="M25.0647 23.9668C29.4993 19.5323 29.4993 12.3425 25.0647 7.90795C25.0647 7.90795 21.4698 11.5028 17.0353 15.9374C12.6008 20.3719 9.00588 23.9668 9.00588 23.9668C9.00588 23.9668 16.7241 31.685 25.0647 23.9668Z"
        fill="#D9D9D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7149 23.2954C12.7112 23.2251 9.4873 19.9576 9.4873 15.9371C9.4873 12.1857 12.294 9.08994 15.922 8.63509L17.3654 10.8868C17.1949 10.8695 17.0219 10.8606 16.8468 10.8606C14.0432 10.8606 11.7704 13.1334 11.7704 15.9371C11.7704 18.1043 13.1285 19.9543 15.04 20.6825L16.7149 23.2954ZM16.3459 20.9891C16.5107 21.0052 16.6778 21.0135 16.8468 21.0135C19.6504 21.0135 21.9232 18.7407 21.9232 15.9371C21.9232 13.7782 20.5756 11.934 18.6756 11.2L16.9955 8.57902C20.9914 8.6582 24.2063 11.9222 24.2063 15.9371C24.2063 19.6831 21.4075 22.7754 17.787 23.2371L16.3459 20.9891Z"
        fill="white"
      />
      <path
        d="M16.7661 21.6328L13.1155 15.9344L16.7661 13.6664L20.6836 15.9344L16.7661 21.6328Z"
        fill="#EDEFFD"
      />
      <path
        d="M20.3964 15.1249L16.7661 13.0256L13.2173 15.1249L16.7661 9.97118L20.3964 15.1249Z"
        fill="#EDEFFD"
      />
      <path d="M16.7248 9.92003L16.772 13.0259L13.2419 15.1113L16.7248 9.92003Z" fill="white" />
      <path d="M16.7659 16.9785L13.1255 15.9537L16.7659 13.6659L16.7659 16.9785Z" fill="#DDDFFB" />
      <path d="M16.7665 16.9785L20.6782 15.9337L16.7665 13.6719L16.7665 16.9785Z" fill="#EDEFFD" />
      <path d="M16.7637 16.9771L16.7638 21.6745L20.6818 15.9351L16.7637 16.9771Z" fill="white" />
      <defs>
        <linearGradient
          id="paint0_linear_15322_4821"
          x1="13"
          y1="0"
          x2="13"
          y2="28.9743"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3985F7" />
          <stop offset="0.397116" stopColor="#6B47F9" />
          <stop offset="0.52715" stopColor="#8E3FAC" />
          <stop offset="0.771456" stopColor="#C75043" />
          <stop offset="1" stopColor="#C74F42" />
        </linearGradient>
      </defs>
    </>
  ),
  viewBox: '0 0 32 32',
}
